import { Box, Typography, Card, CardContent, Button } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import BlockIcon from '@mui/icons-material/Block';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useNavigate } from 'react-router-dom';

export default function ModuloBloqueado({ nome, previsao, semAutorizacao = false }) {
  const navigate = useNavigate();

  if (semAutorizacao) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" minHeight="60vh">
        <Card sx={{ maxWidth: 400, width: '100%', textAlign: 'center' }}>
          <CardContent sx={{ py: 6, px: 4 }}>
            <Box sx={{
              width: 72, height: 72, borderRadius: '50%',
              backgroundColor: '#FCEBEB',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 24px',
              border: '1px solid #f5c6c6',
            }}>
              <BlockIcon sx={{ fontSize: 32, color: '#E24B4A' }} />
            </Box>

            <Typography variant="h6" fontWeight={500} mb={1} color="error">
              Acesso não autorizado
            </Typography>

            <Typography variant="body2" color="text.secondary" mb={3} lineHeight={1.7}>
              Você não tem autorização para acessar o módulo <strong>{nome}</strong>.
              Entre em contato com o administrador do sistema para solicitar acesso.
            </Typography>

            <Button
              variant="outlined"
              color="error"
              onClick={() => navigate('/')}
            >
              Voltar ao início
            </Button>
          </CardContent>
        </Card>
      </Box>
    );
  }

  return (
    <Box display="flex" alignItems="center" justifyContent="center" minHeight="60vh">
      <Card sx={{ maxWidth: 400, width: '100%', textAlign: 'center' }}>
        <CardContent sx={{ py: 6, px: 4 }}>
          <Box sx={{
            width: 72, height: 72, borderRadius: '50%',
            backgroundColor: '#f5f5f5',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 24px',
            border: '1px solid #e0e0e0',
          }}>
            <LockIcon sx={{ fontSize: 32, color: '#9e9e9e' }} />
          </Box>

          <Typography variant="h6" fontWeight={500} mb={1}>
            Módulo em breve
          </Typography>

          <Typography variant="body2" color="text.secondary" mb={3} lineHeight={1.7}>
            O módulo <strong>{nome}</strong> está sendo desenvolvido
            e será liberado para uso em breve.
          </Typography>

          {previsao && (
            <Box display="inline-flex" alignItems="center" gap={1}
              sx={{
                backgroundColor: '#f8f9fa', border: '1px solid #e0e0e0',
                borderRadius: 2, px: 2, py: 1,
              }}>
              <CalendarMonthIcon sx={{ fontSize: 16, color: '#666' }} />
              <Typography variant="caption" color="text.secondary">
                Previsão: <strong style={{ color: '#1a1a2e' }}>{previsao}</strong>
              </Typography>
            </Box>
          )}

          <Box mt={3}>
            <Button variant="outlined" onClick={() => navigate('/')}
              sx={{ borderColor: '#1a1a2e', color: '#1a1a2e' }}>
              Voltar ao início
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}